var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"toTop"}},[_c('span',{on:{"click":function($event){return _vm.scrollToTop(0, 500)}}},[_vm._v("PAGE TOP")])])
}
var staticRenderFns = []

export { render, staticRenderFns }